import {
  SubscriptionPlanFormData,
  SubscriptionPlanFormErrors,
} from "./types";
import { SubscriptionPlanPayload } from "../../services/subscription-plan.service";

export const defaultPlanFormData: SubscriptionPlanFormData = {
  name: "",
  description: "",
  price: "",
  currency: "usd",
  interval: "month",
  appleProductId: "",
  googleProductId: "",
  featuresText: "",
  isPopular: false,
  isActive: true,
};

export const validatePlanForm = (
  data: SubscriptionPlanFormData
): SubscriptionPlanFormErrors => {
  const errors: SubscriptionPlanFormErrors = {};
  const price = Number(data.price);

  if (!data.name.trim()) {
    errors.name = "Plan name is required";
  }

  if (!data.description.trim()) {
    errors.description = "Description is required";
  }

  if (data.price === "" || Number.isNaN(price) || price < 0) {
    errors.price = "Price must be a valid number";
  }

  if (!data.currency.trim()) {
    errors.currency = "Currency is required";
  }

  if (!data.interval) {
    errors.interval = "Billing cycle is required";
  }

  return errors;
};

export const buildPlanPayload = (
  data: SubscriptionPlanFormData
): SubscriptionPlanPayload => {
  const features = data.featuresText
    .split("\n")
    .map((item) => item.trim())
    .filter(Boolean);

  return {
    name: data.name.trim(),
    description: data.description.trim(),
    price: Number(data.price),
    currency: data.currency.trim().toLowerCase(),
    interval: data.interval,
    features,
    appleProductId: data.appleProductId.trim(),
    googleProductId: data.googleProductId.trim(),
    isPopular: data.isPopular,
    isActive: data.isActive,
  };
};
